/**
 * Planning 模块常量定义
 * 
 * @module types/planning/constants
 * @description 计划管理模块（MRP运算、齐套分析）的常量定义
 * 
 * @generated AI-assisted
 * @created 2025-12-09
 */

import { MrpMaterialStatus, KitCheckStatus, PurchaseSuggestionPriority } from './enums'

/**
 * MRP 物料状态标签映射
 */
export const MRP_MATERIAL_STATUS_LABELS: Record<MrpMaterialStatus, string> = {
  [MrpMaterialStatus.CRITICAL]: '严重缺料',
  [MrpMaterialStatus.WARNING]: '缺料警告',
  [MrpMaterialStatus.INFO]: '轻微缺料',
  [MrpMaterialStatus.OK]: '库存充足',
}

/**
 * MRP 物料状态颜色映射（用于UI展示）
 */
export const MRP_MATERIAL_STATUS_COLORS: Record<MrpMaterialStatus, string> = {
  [MrpMaterialStatus.CRITICAL]: 'error',
  [MrpMaterialStatus.WARNING]: 'warning',
  [MrpMaterialStatus.INFO]: 'processing',
  [MrpMaterialStatus.OK]: 'success',
}

/**
 * 齐套状态标签映射
 */
export const KIT_CHECK_STATUS_LABELS: Record<KitCheckStatus, string> = {
  [KitCheckStatus.READY]: '完全齐套',
  [KitCheckStatus.PARTIAL]: '基本齐套',
  [KitCheckStatus.WARNING]: '缺料警告',
  [KitCheckStatus.CRITICAL]: '严重缺料',
  [KitCheckStatus.COMPLETED]: '已完成',
}

/**
 * 齐套状态颜色映射（用于UI展示）
 */
export const KIT_CHECK_STATUS_COLORS: Record<KitCheckStatus, string> = {
  [KitCheckStatus.READY]: 'success',
  [KitCheckStatus.PARTIAL]: 'warning',
  [KitCheckStatus.WARNING]: 'warning',
  [KitCheckStatus.CRITICAL]: 'error',
  [KitCheckStatus.COMPLETED]: 'default',
}

/**
 * 采购建议优先级标签映射
 */
export const PURCHASE_PRIORITY_LABELS: Record<PurchaseSuggestionPriority, string> = {
  [PurchaseSuggestionPriority.URGENT]: '紧急',
  [PurchaseSuggestionPriority.HIGH]: '高',
  [PurchaseSuggestionPriority.MEDIUM]: '中',
  [PurchaseSuggestionPriority.LOW]: '低',
}

/**
 * 采购建议优先级颜色映射
 */
export const PURCHASE_PRIORITY_COLORS: Record<PurchaseSuggestionPriority, string> = {
  [PurchaseSuggestionPriority.URGENT]: 'error',
  [PurchaseSuggestionPriority.HIGH]: 'warning',
  [PurchaseSuggestionPriority.MEDIUM]: 'processing',
  [PurchaseSuggestionPriority.LOW]: 'default',
}

/**
 * 齐套率阈值配置
 */
export const KIT_RATE_THRESHOLDS = {
  /** 完全齐套阈值（≥100%） */
  READY: 100,
  /** 基本齐套阈值（≥80%） */
  PARTIAL: 80,
  /** 警告阈值（≥50%） */
  WARNING: 50,
  /** 严重缺料阈值（<50%） */
  CRITICAL: 50,
} as const

/**
 * 缺料率阈值配置
 */
export const SHORTAGE_RATE_THRESHOLDS = {
  /** 严重缺料阈值（≥80%） */
  CRITICAL: 80,
  /** 警告阈值（≥50%） */
  WARNING: 50,
} as const
